import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { VitalSignEffects } from './+state/vital-sign.effects';
import { metaReducers } from './+state/storage.metareducer';

import * as fromVitalSign from './+state/vital-sign.reducer';


const SERVICES = [
];

const MODULES = [
  CommonModule,
];

const STATE_MODULES = [
  StoreModule.forFeature(fromVitalSign.vitalSignsFeatureKey, fromVitalSign.reducer, { metaReducers }),
  EffectsModule.forFeature([VitalSignEffects]),
];

@NgModule({
  imports: [MODULES, STATE_MODULES],
  providers: [SERVICES]
})
export class StateVitalSignModule { }
